import { casOpsApi, CollectionModel, QueryTag, TagList } from '../api';
import { ModelWithId } from './commonModels';

export enum TriggerSource {
  CasOps = 'CasOps',
  Portal = 'Portal',
}

export enum DeliveryStatus {
  Unknown = 'Unknown',
  WaitingForCasOps = 'WaitingForCasOps',
  WaitingForDevice = 'WaitingForDevice',
  RejectedByCas = 'RejectedByCas',
  TimedOut = 'TimedOut',
  Processing = 'Processing',
  UnsupportedByDevice = 'UnsupportedByDevice',
  RejectedByDevice = 'RejectedByDevice',
  DeviceFailedToProcess = 'DeviceFailedToProcess',
  Completed = 'Completed',
}

export interface DeviceMessageModel extends ModelWithId {
  did?: string; // Device ID
  src: TriggerSource;
  typ: string; // Message type
  tsUpd: string; // Last updated time
  tsCre: string; // Message creation time
  tsExp: string; // Message expiry time
  sts: DeliveryStatus;
  diag: string; // Diagnostic message
}

export const deviceMessagesApi = casOpsApi.injectEndpoints({
  endpoints: build => ({
    getListDeviceMessages: build.query<DeviceMessageModel[], void>({
      query: () => 'api/devicemessages',
      providesTags: (result, error, arg) =>
        result ? [{ type: QueryTag.DeviceMessage, id: TagList }] : [],
      transformResponse: ({ items }: CollectionModel<DeviceMessageModel>, meta, arg) => items,
    }),
    getListDeviceMessagesForAsset: build.query<DeviceMessageModel[], number>({
      query: (assetId: number) => `api/devicemessages?assetId=${assetId}`,
      providesTags: (result, error, arg) =>
        result ? [{ type: QueryTag.DeviceMessage, id: arg }] : [],
      transformResponse: ({ items }: CollectionModel<DeviceMessageModel>, meta, arg) => items,
    }),
  }),
  overrideExisting: false,
});

export const { useGetListDeviceMessagesQuery, useGetListDeviceMessagesForAssetQuery } =
  deviceMessagesApi;
